export const SOCIALS = [
  { name: "YouTube", icon: "Youtube", url: "https://www.youtube.com/@orphôss" },
  { name: "Facebook", icon: "Facebook", url: "https://www.facebook.com/steevehorphoss" },
  { name: "Instagram", icon: "Instagram", url: "https://www.instagram.com/steeveorphosss/" },
  { name: "WhatsApp", icon: "MessageCircle", url: "https://wa.me/33758798906" },
];

export const MINISTRY = {
  name: "PROPHÈTE STEEVE ORPHÔSS",
  email: "steeveorphss@gmail.com",
  phone: "+33 7 58 79 89 06",
  whatsappFr: "33758798906",
  whatsappCi: "2250777162739",
  whatsappFrDisplay: "+33 7 58 79 89 06",
  whatsappCiDisplay: "+225 07 77 16 27 39",
  facebookUrl: "https://www.facebook.com/steevehorphoss",
  youtubeUrl: "https://www.youtube.com/@orphôss",
  tagline: "Un message pour cette génération, une voix prophétique pour les nations.",
  portrait: "/prophete-hero.jpg",
};

export const NAV_LINKS = [
  { label: "Accueil", to: "/" },
  { label: "À propos", to: "/a-propos" },
  { label: "Vidéos", to: "/videos" },
  { label: "Boutique", to: "/boutique" },
  { label: "Contact", to: "/contact" },
];
